import styled from "styled-components";

export const Container = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 200px;
background-color: #fff;
-webkit-box-shadow: 0px 0px 35px -14px rgba(0,0,0,0.2);
-moz-box-shadow: 0px 0px 35px -14px rgba(0,0,0,0.2);
box-shadow: 0px 0px 35px -14px rgba(0,0,0,0.2);
`;

export const ImageLogo = styled.img`
width: 150px;
`;